<span idOrDefault class="label-heading" *ngIf="label">{{ label }}</span>
<select
  class="dropdown"
  [attr.data-e2e]="e2eId"
  [name]="inputName"
  [disabled]="disabled"
  [value]="value"
  (change)="onChange($event.target.value)"
  (blur)="onBlur()"
  [idOrDefault]="inputId"
>
  <option
    value=""
    selected
    disabled
    class="dropdown-option-default"
    *ngIf="enableDefaultOption"
  >
    {{ defaultOptionText }}
  </option>
  <option
    *ngFor="let item of internalOptions"
    [value]="item.value"
    [selected]="item.selected"
  >
    {{ item.text }}
  </option>
</select>
<nibtravel-validation
  [validations]="validations"
  [control]="ngControl.control"
  [host]="formComponent"
  [errorMessageOnFormGroup]="errorMessageOnFormGroup"
  [enableDistinctUntilChanged]="enableDistinctUntilChanged"
  (errorEmitter)="error.emit($event)"
  *ngIf="validations"
></nibtravel-validation>
